<template>
  <div v-if="loading" class="flex items-center justify-center h-full">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="() => { error.title = ''; error.body = '' }"
  />

  <div v-else>
    <div class="flex flex-row">
      <div class="flex flex-col">
        <action-button :title="t('print')" faIcon="print" @click="print" />
        <action-button
          :title="t('backToQuote')"
          faIcon="arrow-left"
          @click="$router.push($Route.SALES_QUOTES_QUOTE.replace(':id', order.id))"
        />
      </div>

      <SaleReceiptA4
        v-if="$ctx.getReceiptSize() == 'a4' || $ctx.getReceiptSize() == 'a5'"
        :order="order"
        :transactions="[]"
        :barcodeText="barcodeText"
        :isQuote="true"
      />

      <SaleReceiptSmall
        v-if="$ctx.getReceiptSize() == 'receipt'"
        :order="order"
        :transactions="[]"
        :barcodeText="barcodeText"
        :isQuote="true"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { Order } from '@/models/sales/Order'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import ActionButton from '@/components/ActionButton.vue'
import SaleReceiptA4 from './SaleReceiptA4.vue'
import SaleReceiptSmall from './SaleReceiptSmall.vue'

export default defineComponent({
  components: {
    SaleReceiptA4,
    SaleReceiptSmall,
    LoadingSpinner,
    AlertBadge,
    ActionButton
  },

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          print: 'Print Quote',
          backToQuote: 'Back to Quote'
        },
        ar: {
          print: 'طباعة عرض السعر',
          backToQuote: 'العودة لعرض السعر'
        }
      }
    })

    return { t }
  },

  data() {
    return {
      order: new Order(),
      loading: true,
      barcodeText: '',
      error: { title: '', body: '' }
    }
  },

  async mounted() {
    try {
      const id = this.$route.params.id as string
      const resp = await this.$http.get<Order>(`/sales/quotes/${id}`)
      this.order = Order.from(resp)
    } catch (err: any) {
      this.error.title = err.title || 'Error'
      this.error.body = err.body || ''
    } finally {
      this.loading = false
      this.barcodeText = `${this.order.externalID!.slice(
        0,
        5
      )}-${this.order.externalID!.slice(5)}`
    }
  },

  methods: {
    print() {
      window.print()
    }
  }
})
</script>

<style></style>
